import React from "react";
import Map, { Marker, Popup } from '../../../../../../../lib/Map';
import {
  getDispatchRouteStopsMarker,
  getDispatchUnassignedPickupMarker
} from '../../../../../../mapComponents/mapHelper';
import {
  DispatchStopPickupPopupInfo,
  DispatchStopDeliveryPopupInfo,
  DispatchUnassignedPickupPopupInfo,
} from "../../../../../../mapComponents/Popups";
import { withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { TerminalMarker } from "../../../../../../mapComponents/Markers";
import appConstants from "../../../../../../../appConstants";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { getStopMarkerColors } from "../../../DriverMap/utils";
import { withAppConfig } from "../../../../../../../appConfigContext";
import { getSpecialNeedsOptionsWithServiceLevel } from "../../../../../utils";
import MapZoomChange from "../../../../../../../lib/Map/Trimble/components/MapZoomChange";
import { getRouteData, getVirtualStopMarker } from "../../../../../../header/dispatchHeader/PickupOptimization/Map/utils";
import { hasStopDelayed } from "../../../utils";
import { getPickupStatus, getPickupStatusTypeIcon } from "../../../utils/pickupStatusTypeIcon";
import { getPickupCountForPickupMarkerBadge } from "../../../../utils/utils";
import RouteMapControls from "./components/RouteMapControls";
import RouteDirections from "../../../DriverMap/RouteDirections";
import DriverMarkers from "./components/DriverMarkers";

@inject("DispatchStore")
@observer
class RouteMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStop: null,
      selectedPickups: [],
      selectedPickup: null,
    };
  }

  onRouteStopClicked = (stop) => {
    this.stopSelectedOnMap = true;
    this.setState({
      selectedStop: stop,
    });
  };

  onMapClicked = () => {
    this.stopSelectedOnMap = false;
    this.pickupSelectedOnMap = false;
    if (this.state.selectedStop || this.state.selectedPickup) {
      this.setState({
        selectedStop: null,
        selectedPickup: null,
      });
    }
  };

  onPickupMarkerClicked = (selectedPickup) => {
    const isActivePickup = this.props.selectedUnassignPickupIds.includes(
      selectedPickup.data.pickupId
    );
    if (isActivePickup) {
      this.pickupSelectedOnMap = false;
      this.setState({selectedPickup: null})
      this.props.onUnassignPickupDeselection(selectedPickup.data.pickupId);
    } else {
      this.pickupSelectedOnMap = true;
      this.setState({selectedPickup});
      this.props.onUnassignPickupSelection(selectedPickup.data);
    }
  };

  getPickupActiveStatus = (pickup) => {
    const isPickupSelectedOnMap =
      pickup.pickupId.toLowerCase() ===
      this.state.selectedPickup?.data?.pickupId?.toLowerCase();
    const isPickupSelectedInGrid = this.props.selectedUnassignPickupIds.includes(
      pickup.pickupId
    );
    const isPickupActive = isPickupSelectedOnMap || isPickupSelectedInGrid;
    return { isPickupActive, isPickupSelectedInGrid };
  };

  render() {
    const {
      theme,
      selectedRoutes,
      unassignedPickups,
      DispatchStore,
      userData,
      glEventHub,
      mapId,
      showDriverLabel=false,
      isAutoZoomEnabled = true,
    } = this.props;
    const { selectedStop, selectedPickup } = this.state;
    let [isDeliveryStop, isPickupStop] = [false, false];
    let stopPopupCommonProps = {},
      routesData,
      specialNeeds;
    const { offset, location: terminalLocation } = userData.userProfile.terminal;
    if (selectedStop) {
      routesData = getRouteData(selectedRoutes, selectedStop.data.driverId);
    }

    if (this.stopSelectedOnMap) {
      specialNeeds = getSpecialNeedsOptionsWithServiceLevel(DispatchStore.priorityAllShipmentList);
      isDeliveryStop =
        selectedStop.data.stopType === appConstants.STOP_TYPE.Delivery;
      isPickupStop =
        selectedStop.data.stopType === appConstants.STOP_TYPE.Pickup;
      stopPopupCommonProps = {
        glEventHub,
        stopData: selectedStop.data,
        routesData,
        isDelayStop: hasStopDelayed(selectedStop.data),
        specialNeeds,
        terminalOffset: offset,
        enableBulkEditAndVoid: Boolean(this.props.configJSON?.enableBulkEditAndVoid),
      };
    }

    let pickupStops = [],
      deliveryStops = [];
    selectedRoutes?.forEach((route) =>
      route.stops?.forEach((stop) => {
        if (stop.pickupId) {
          pickupStops = [...pickupStops, stop];
        } else {
          deliveryStops = [...deliveryStops, stop];
        }
      })
    );

    return (
      <Map
        zoom={appConstants.MAP_ZOOM_LEVEL}
        initialCenter={terminalLocation}
        center={terminalLocation}
        mapId={mapId}
        mapTheme={theme.themeName}
        eventHub={glEventHub}
        mapConfig={this.props.configJSON?.maps}
        onClick={this.onMapClicked}>
        <RouteMapControls />
        <Marker
          position={terminalLocation}
          zIndex={2}
          forceUpdate
          isActiveShipment
          easeToAnimation
          mapZoomLevel={appConstants.MAP_ZOOM_LEVEL}>
          <TerminalMarker
            data={this.props.userData.userProfile.terminal}
            color={theme.terminalContentColor}
          />
        </Marker>

        <RouteDirections
          selectedRoutes={selectedRoutes}
          terminalLocation={terminalLocation}
          disableRouteAnimation={this.disableRouteAnimation}
          routeAnimation={isAutoZoomEnabled}
          refreshOnMapStyleLoaded
          showRouteAnimation
        />
        <DriverMarkers
          theme={theme}
          driverIds={selectedRoutes?.map((route) => route.driverId)}
          showDriverLabel={showDriverLabel}
        />

        {deliveryStops.map((stop) => (
          <Marker
            data={{ ...stop }}
            position={{ lat: stop.latitude, lng: stop.longitude }}
            key={`${stop.stopId}_${stop.stopSequence}`}
            zIndex={stop.stopId === selectedStop?.data?.stopId ? 2 : 1}
            onClick={this.onRouteStopClicked}>
            {getDispatchRouteStopsMarker({
              stop,
              ...getStopMarkerColors({
                theme,
                stop,
                routeColor: stop.color
              }),
              isSelectedStop: Boolean(selectedStop?.data?.stopId === stop.stopId)
            })}
          </Marker>
        ))}

        <MapZoomChange thresholdZoomLevel={11}>
          {pickupStops?.map((stop) => {
            const isSelectedStop = Boolean(selectedStop?.data?.stopId === stop.stopId);
            return (
              <Marker
                data={stop}
                position={{ lat: stop.latitude, lng: stop.longitude }}
                key={stop.stopId}
                zIndex={isSelectedStop ? 2 : 1}
                onClick={this.onRouteStopClicked}>
                {stop.isVirtualStop
                  ? getVirtualStopMarker({
                      pickup: stop,
                      stopSequence: stop.stopSequence,
                      isSelectedStop,
                      theme,
                      routeColor: stop.color
                    })
                  : getDispatchRouteStopsMarker({
                      stop,
                      ...getStopMarkerColors({
                        theme,
                        stop,
                        routeColor: stop.color
                      }),
                      isSelectedStop
                    })}
              </Marker>
            );
          })}

          {unassignedPickups?.map((pickup, i) => {
            const { isPickupActive, isPickupSelectedInGrid } = this.getPickupActiveStatus(pickup);
            return (
              <Marker
                position={{
                  lat: pickup.shipperLatitude,
                  lng: pickup.shipperLongitude
                }}
                onClick={this.onPickupMarkerClicked}
                zIndex={isPickupActive ? 1 : 0}
                key={pickup.pickupId}
                isActiveShipment={isAutoZoomEnabled && isPickupSelectedInGrid}
                data={pickup}>
                {getDispatchUnassignedPickupMarker({
                  isActive: isPickupActive,
                  theme,
                  pickupCount: getPickupCountForPickupMarkerBadge(pickup),
                  pickupStatus: getPickupStatus({
                    pickup,
                    theme,
                    terminalOffset: DispatchStore.terminalOffset,
                    newPickupDuration: this.props.configJSON?.newPickupDuration
                  })
                })}
              </Marker>
            );
          })}
        </MapZoomChange>

        {selectedPickup && this.pickupSelectedOnMap && (
          <Popup
            position={selectedPickup.position}
            key={`${selectedPickup.data.pickupId}_pickupPopup`}>
            <DispatchUnassignedPickupPopupInfo
              theme={theme.themeName}
              hideAction
              specialNeeds={getSpecialNeedsOptionsWithServiceLevel(
                DispatchStore.priorityAllShipmentList
              )}
              data={{ data: selectedPickup.data }}
              hideTerminalChange
              markerComponent={getPickupStatusTypeIcon({
                theme,
                status: getPickupStatus({
                  pickup: selectedPickup.data,
                  terminalOffset: DispatchStore.terminalOffset,
                  newPickupDuration: this.props.configJSON?.newPickupDuration
                })
              })}
              showPickupHistory={false}
              enableBulkEditAndVoid={Boolean(this.props.configJSON?.enableBulkEditAndVoid)}
            />
          </Popup>
        )}

        {isDeliveryStop && (
          <Popup marker={selectedStop.marker}>
            <DispatchStopDeliveryPopupInfo {...stopPopupCommonProps} />
          </Popup>
        )}

        {isPickupStop && (
          <Popup marker={selectedStop.marker}>
            <DispatchStopPickupPopupInfo
              hideAction
              pickupNumber={selectedStop.data.pickupNumber}
              showPickupHistory={false}
              {...stopPopupCommonProps}
            />
          </Popup>
        )}
      </Map>
    );
  }
}

export default compose(withTheme(), withUserProfile, withAppConfig)(RouteMap);
